<template>
  <div>
  <el-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24" style="margin-top: 30px;">
    <el-col :lg="13" :md="13" :sm="13" :xl="12" :xs="24">
      <el-checkbox @change="setSpaceHostWholeSpace" v-model="wholeSpace">全部空间</el-checkbox>
    </el-col>

    <el-col :lg="9" :md="9" :sm="9" :xl="8" :xs="18">
      <el-select v-model="gatewaySn" @change="setSpaceHostGatewaySn" size="mini" :placeholder="selectTisp" style="width: 90%;"
                 :disabled="showHide">
        <el-option v-for="item in gatewayList"
                   :key="item.snCode"
                   :label="item.name"
                   :value="item.snCode">
        </el-option>
      </el-select>
    </el-col>

    <el-col :xl="1" :lg="2" :md="2" :sm="2" :xs="3">
      <el-button @touchstart="add" @click="add" size="mini" style="color: #07E6F8"> +</el-button>
    </el-col>
  </el-col>


    <notification-object v-for="(item,index) in spaceHostList"
                         :item="item"
                         :key="index"
                         :spaceHostList="spaceHostList"
                         :spaceList="spaceList"
                         :gatewayList="gatewayList"
                         @add="add"
                         @deleteIndex="del(index)"
                         @uploadData="getData"/>
  </div>
</template>

<script>
import NotificationObject
  from "@/views/basic_operations/sys_setting/notification_configuration/public_configuration/NotificationObject";

export default {
  name: "SpaceHost",
  props:["type","spaceHostList","wholeSpace","gatewaySn","spaceList","gatewayList"],
  components:{NotificationObject},
  data(){
    return{
      showHide: false,
      selectTisp: '请选择一个主机',
    }
  },
  created() {
    this.selectGatewaySn(this.wholeSpace);
  },
  watch:{
    wholeSpace(spaceState){
      this.selectGatewaySn(spaceState);
    }
  },
  methods:{
    selectGatewaySn(spaceState){
      if (spaceState){
        this.showHide = false;
        this.selectTisp = '请选择一个主机';
      }else{
        this.showHide = true;
        this.gatewaySn = "";
        this.$emit("setGatewaySn","");
        this.selectTisp = '请先勾选全部空间';
      }
    },

    //添加一列
    add(){
      let form={
        gatewaySn:'',
        spaceIds:[],
        inverse: false,
        // 发送方式
        type: this.type,
      };
      this.spaceHostList.push(form);
    },

    // 删除一列
    del: function (index) {
      this.spaceHostList.splice(index, 1);
    },

    //  get the data from child
    getData: function (val) {
      let index = val.index;
      this.spaceHostList[index] = val.data
    },

    setSpaceHostWholeSpace(data){
      console.log("里面选中主机：", data);
      this.$emit("setWholeSpace",data);
    },

    setSpaceHostGatewaySn(data){
      console.log("里面选中主机：", data);
      this.$emit("setGatewaySn",data);
    }
  }
}
</script>

<style scoped>
</style>
